import { createDevextremeDatasource } from '@/letapps-vue/utils/useRestApi';

let store;

export function getKvartalsrapportDatasource() {
  if (!store) {
    store = createDevextremeDatasource('/api/Kvartalsrapport', 'id', {
      paginate: false,
    });
  }

  return store;
}
